import styles from './FilterLayout.module.scss'
import Button from 'src/components/button/Button';
import DatePicker  from 'src/components/date-picker/DatePicker';
import type { DatePickerProps } from 'antd';
import Spinner from '@src/components/spinner/Spinner';
import dayjs from 'dayjs';
import type { RangePickerProps } from 'antd/es/date-picker';
import moment from 'moment';
import { SelectOption } from '@types';
import { TextInput, TextInputValue } from '@src/components/text-input/TextInput';
import Select from '@src/components/select/Select';
import SelectMulti from '@src/components/select-multi/SelectMulti';


type Props = {
  name: string;
  startDate: string;
  endDate: string;
  loading?: boolean;
  handleChangeStart: (value: string) => void
  handleChangeEnd: (value: string) => void
  handleChangeName: (value: string) => void
  handleResetFilters: () => void
  handleGenerateReport: () => void
  isDistrictAdmin?: boolean;
  schoolOptions: SelectOption[];
  schoolFilter: string[] | undefined;
  handleChangeSchool: (value: string[]) => void
  reportType: string;
  handleReportType: (value: SelectOption) => void
  listOptions: Array<{label: string; value: string}>
}

function FilterLayout(props: Props) {
  const { name, startDate, endDate, loading, handleChangeStart, handleChangeEnd,
     handleGenerateReport, handleChangeName, schoolOptions, isDistrictAdmin, handleChangeSchool, schoolFilter, reportType, handleReportType } = props
  const onChangeStartDate: DatePickerProps['onChange'] = (date, dateString) => {
    handleChangeStart(dateString)
  };

  const onChangeEndDate: DatePickerProps['onChange'] = (date, dateString) => {
    handleChangeEnd(dateString)
  };

  const onChangeName = (value: TextInputValue) => {
    handleChangeName(value.toString())
  }

  const disabledDate: RangePickerProps['disabledDate'] = (current) => {
    if (endDate) {
      return current > moment(endDate, 'MMM DD, YYYY')
    }
    return current < moment(startDate, 'MMM DD, YYYY') || current > dayjs().endOf("day");
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.filters}>
        <Select
          inDropDown={true}
          value={reportType}
          onChange={handleReportType}
          label={'Report Type'}
          options={props.listOptions}
          className={styles.selection}
        />
        {isDistrictAdmin ? (
          <SelectMulti
            value={schoolFilter ? schoolFilter : []}
            onChange={handleChangeSchool}
            label={'School(optional)'}
            options={schoolOptions}
            className={styles.selection}
          />
        ) : null}
        <TextInput id="name" label={'Report Name(optional)'} value={name} placeholder='Report Name' onChange={onChangeName} className={styles.selection}/>
        <div className={styles.dateSelection}>
          <DatePicker label='Start Date' dateFormat={"MMM DD, YYYY"} disabledDate={disabledDate} value={startDate} onChange={onChangeStartDate} className={styles.selection} />
          <DatePicker label='End Date' dateFormat={"MMM DD, YYYY"} disabledDate={disabledDate} value={endDate} onChange={onChangeEndDate} className={styles.selection} />
        </div>
      </div>
      <Button disabled={!startDate || !endDate || loading || !reportType} label={'Generate Report'} size={'small'} className={styles.generateBtn} onClick={handleGenerateReport} leftIcon={loading ? <Spinner width={20} height={20} /> : undefined} />
    </div>
  )
}

export default FilterLayout
